"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unwrap = unwrap;

function unwrap(val) {
  if (val === undefined || val === null) {
    throw new Error('Trying to unwrap an undefined or null value');
  }

  return val;
}